export default __webpack_public_path__ + "static/11014-ce7c0a5c08cc3b59f38493255e8b5626.jpg";